import { render, staticRenderFns } from "./RimconfigKbaImageZoomDialog.vue?vue&type=template&id=997516c6"
import script from "./RimconfigKbaImageZoomDialog.vue?vue&type=script&lang=js"
export * from "./RimconfigKbaImageZoomDialog.vue?vue&type=script&lang=js"
import style0 from "./RimconfigKbaImageZoomDialog.vue?vue&type=style&index=0&id=997516c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports